export enum DATA_LOCATION {
  NONE = 'none',
  LOCAL = 'local',
  SERVER = 'server',
  BOTH = 'both',
}

export interface Published {
  nanoseconds: number;
  seconds: number;
}

export interface Info {
  value: string;
  name: string;
}

export interface Module {
  padding: string;
  divider: boolean;
  label: string;
  type: string;
  geo_restricted: boolean;
  padding_top: string;
  padding_bottom: string;
  bgColor: string;
  promoIndex: string;
  tableType: string;
  limit: string;
  url: string;
  aspect_ratio?: number;
  open_inapp?: boolean;
}

export interface Condition {
  modules: Module[];
  predefinedrule: string;
  scene: string;
}

export interface SceneConfig {
  condition: Condition;
}

export interface Link {
  imageUrl: string;
  targetUrl: string;
}

export interface TeamData {
  author?: string;
  id: string;
  abbrv: string;
  info: Info[];
  links: Link[];
  squadImage: string;
  image: string;
  headerImageUrl: string;
  logoImageUrl: string;
  feedLogoImageUrl: string;
  ticketType: string;
  hash: string;
  name: string;
  forzasysId: number;
  forzasysImportSource: string;
  forzasysImportId: number;
  fogisId: number;
  everySportId: number;
  unibetId: number;
  epId: number;
  matchCardCacheKey: string;
  newsRssUrl: string;
  tv4: string;
  urlPolicy: string;
  abbrvAliases: string;
}

export interface ExtendedTeamData extends TeamData {
  published: Published;
  author: string;
}

export type ExtendedTeamPaths = ['author', 'published'];

export interface PromoFieldData {
  scene: string;
  promoIndexes: string[] | [];
}

export interface SceneNamesInUse {
  mobile: string;
  tablet: string;
}

export interface PromosInUse {
  'promo-0': SceneNamesInUse;
  'promo-1': SceneNamesInUse;
  'promo-2': SceneNamesInUse;
  'promo-3': SceneNamesInUse;
  'promo-4': SceneNamesInUse;
  'promo-5': SceneNamesInUse;
  'promo-6': SceneNamesInUse;
  'promo-7': SceneNamesInUse;
  'promo-8': SceneNamesInUse;
  'promo-9': SceneNamesInUse;
  'promo-10': SceneNamesInUse;
  'promo-11': SceneNamesInUse;
  'promo-12': SceneNamesInUse;
  'promo-13': SceneNamesInUse;
  'promo-14': SceneNamesInUse;
  'promo-15': SceneNamesInUse;
  'promo-16': SceneNamesInUse;
  'promo-17': SceneNamesInUse;
}

export enum PROMO_VARIANT {
  IMAGE = 'IMAGE',
  FORZASYS_VIDEO = 'FORZASYS_VIDEO',
  POLL = 'POLL',
  SUBSCRIPTION = 'SUBSCRIPTION',
  FLARIE = 'FLARIE',
  NONE = '',
}
